<template>
    <svg
        id="tunnel"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
        viewBox="-100 -100 200 200"
        visibility="hidden"
    ></svg>
</template>

<script>
export default {
    name: 'TunnelComponent'
};
</script>
